import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import '../../asset/css/stepbystepform.css';
import {
    fetchUtilData,
} from "./api";

import {ColumnChart, LineChart, PieChart} from 'react-chartkick';
import 'chart.js';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import MyNewSchedule from './popup-new-schedule';
import PopupIssue from "../flauts/popup-issue";
import {FindImages, GetSectionFromDatabaseEntity} from "../generic/find-data";
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from "../../config";

import MyPopupSchStatus from "./popup-status-schedule";
import MyPopupSchEmail from "./popup-send-email-schedule";


export default class ComFleetDashboardVehicle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Vehicles: [],
            JobSchedules: [],
            Drivers: [],
            PersonnelAttributes: [],
            DriverAttributes: [],
            VehicleAttributes: [],
            AssignDrivers: [],
            Suppliers: [],
            SupplierAttributes: [],
            DatabaseOptions: [],
            showNewSchedule: false,
            showScheduleStatus: false,
            showScheduleEmail: false,
            selectedJob: null,
            RequestFromDue:false,

        }
    }

    async componentDidMount() {
        await this.loadInitialData();

        // localStorage.setItem("REQ_SCHEDULE",JSON.stringify(row))
        if (localStorage.getItem("REQ_SCHEDULE") !== null) {
            this.openNewSchedule();
            this.setState({RequestFromDue:true});
            localStorage.removeItem("REQ_SCHEDULE");
        }
    }

    loadInitialData = async () => {
        await fetchUtilData(this, "GeneralTableData", "Vehicles", "vehicle");
        await fetchUtilData(this, "GeneralTableField", "VehicleAttributes", "vehicle");
        await fetchUtilData(this, "Documents", "Files", "vehicle");
        await fetchUtilData(this, "GeneralTableField", "DriverAttributes", "driver");
        await fetchUtilData(this, "GeneralTableData", "Drivers", "driver");
        await fetchUtilData(this, "GeneralTableField", "PersonnelAttributes", "personnel");
        await fetchUtilData(this, "GeneralTableData", "Personnel", "personnel");
        await fetchUtilData(this, "UtilDatabaseOptions", "DatabaseOptions", "vehicle");

        await fetchUtilData(this, "GeneralTableField", "SupplierAttributes", "supplier");
        await fetchUtilData(this, "GeneralTableData", "Suppliers", "supplier");

        //supplier
        await this.fetchVehicleDriver();
        await this.fetchJobScheduleProcessing();
        await this.fetchAssignJobs(this);

    }
     fetchAssignJobs = async (_this) => {

        let conds = [{
            Key: "org",
            Val: GetUserToken().OrgCode,
            Type: "string"
        }];
        await this.fetchingAll("AssignJob", conds, (data) => {
            console.log("fetchAssignJobs :> ", data);
            _this.setState({
                AssignJobs:data,
            });

        });
    }
    fetchingAll = async (table, conds, callback) => {
        let hub = {
            Fields: [],
            DbName: "fleetminder",
            TableName: table,
            Conditions: conds,
        }
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            //console.log("fetchingAll response > ", table, dataIn);
            if (dataIn === null) {
                callback([]);
                return null
            }
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;

                callback(data);
            } else {
                callback([]);
            }
        });
    }
    fetchJobScheduleProcessing = async () => {
        let _this = this;
        const user = GetUserToken();
        const hub = {
            Org: user.OrgCode,
            /*JobFrom string
            Vehicle string
            JobStatus string*/
            Stage: "processing"
        }

        let backend = eConfig.mainBackend;
        let endpoint = "/api/fleet/job/schedule/list";

        console.log("fetchJobScheduleProcessing send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchJobScheduleProcessing response > ", dataIn);
            if (dataIn === null) {
                return null
            }
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                _this.setState({
                    JobSchedules: data
                })

            } else {
                return null
            }
        });


    }
    fetchVehicleDriver = async () => {
        let _this = this;
        let conds = [{
            Key: "org",
            Val: GetUserToken().OrgCode,
            Type: "string"
        }];
        await this.fetchingAll("VehicleDriver", conds, (data) => {
            console.log("fetchVehicleDriver :> ", data);
            //const keyOne = "position";
            /*data.sort((a, b) => (a[keyOne] > b[keyOne]) ? 1 : -1)*/
            _this.setState({
                AssignDrivers: data
            });

        });
    }


    buildData = () => {
        const imgLink = "data:image/jpeg;base64,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";
        let _this = this;
        let ls = [
            /*{
                imageLink: imgLink,
                ref: "CA 789 987",
                vehicleInfo: [{brand: "Toyoto", model: "Yaris", year: "2015"}],
                createOn: "2019-11-13",
                requiredBy: "2019-11-15",
                requireStatus: "Over Due",
                requiredColor: "red",
                personInCharge: "Nathan Dikamba",
                sendNotification: "Yes",
                personnelInChargeEmail: "imbeni16@gmail.com",
                vendorInCharge: "N/D",
                vendorInChargeEmail: "N/D",
                Services: 10,
                serviceList: ["Check tire inflation", "Check windshield", "check wiper"],
                reference: "WO0000002",
                state: "Pending",
                comments: "will need a vehicle by end week for long trip"
            }, {
                imageLink: imgLink,
                ref: "CA 789 987",
                vehicleInfo: [{brand: "Toyoto", model: "Yaris", year: "2015"}],
                createOn: "2019-11-13",
                requiredBy: "2019-11-15",
                requireStatus: "Over Due",
                requiredColor: "red",
                personInCharge: "Nathan Dikamba",
                sendNotification: "Yes",
                personnelInChargeEmail: "imbeni16@gmail.com",
                vendorInCharge: "N/D",
                vendorInChargeEmail: "N/D",
                Services: 10,
                serviceList: ["Check tire inflation", "Check windshield", "check wiper"],
                reference: "WO0000002",
                state: "Pending",
                comments: "will need a vehicle by end week for long trip"
            },*/
        ];

        for (let i in this.state.JobSchedules) {
            const schedule = this.state.JobSchedules[i];
            let tasks = [];
            let inchargeName = "N/D";
            let inchargeEmail = "N/D";
            const checkSource = schedule.SourceLabour || "internal";
            if (checkSource === "internal") {
                const o = GetSectionFromDatabaseEntity(
                    this.state.Personnel,
                    this.state.PersonnelAttributes,
                    "names",
                    schedule.PersonInCharge,
                    "object"
                );
                inchargeName = o.val;
                inchargeEmail = o.key;
            } else {
                const o = GetSectionFromDatabaseEntity(
                    this.state.Suppliers,
                    this.state.SuppliersAttributes,
                    "identity",
                    schedule.PersonInCharge,
                    "object"
                );
                inchargeName = o.val;
                inchargeEmail = o.key;
            }

            for (let i in schedule.Tasks) {
                tasks.push(i);
            }


            ls.push({
                imageLink: FindImages(schedule.Vehicle, this.state.Files),
                ref: schedule.Vehicle,
                vehicleInfo: GetSectionFromDatabaseEntity(
                    this.state.Vehicles,
                    this.state.VehicleAttributes,
                    "general",
                    schedule.Vehicle,
                    "array"
                ),
                createOn: schedule.RequiredOn,
                requiredBy: schedule.RequiredBy,
                requireStatus: schedule.RequiredStatus,
                requiredColor: "black",//todo let get the color associate with status later
                sendNotification: "Yes",
                inChargeEmail: inchargeEmail || schedule.PersonInCharge,
                inChargeName: inchargeName || schedule.PersonInCharge,
                inChargeSource: checkSource,
                Services: tasks.length,
                serviceList: tasks,
                reference: "N/D",
                state: schedule.RequiredStatus,
                comments: schedule.Note,
                jobNumber: schedule.JobNumber,
                jobFrom: schedule.JobFrom,
            })

        }

        return ls

    }

    openNewSchedule = () => {
        this.setState({
            showNewSchedule: true
        })
    }
    openScheduleEmail = ( row) => {
        this.setState({
            showScheduleEmail: true,
            selectedJob: row,
        });


    }
    closeNewSchedule = () => {
        this.setState({
            showNewSchedule: false
        });

        if(this.state.RequestFromDue){
            localStorage.removeItem("REQ_SCHEDULE");
            window.location.href="#/fleet-dashboard-task-due";
        }
    }

    openChangeStatus = (row) => {
        this.setState({
            showScheduleStatus: true,
            selectedJob: row,
        })
    }
    CloseChangeStatus = (row) => {
        this.setState({
            showScheduleStatus: false,
            selectedJob: null,
        })
    }
    CloseScheduleEmail = () => {
        this.setState({
            showScheduleEmail: false,
            selectedJob: null,
        })
    }
    sendEmailToAssign = (row) => {

    }

    renderVehicleList = () => {
        const ls = this.buildData();

        let vDetail = "";

        const objetArrayToHtmlTag = (inList) => {
            return inList.map((row) => {
                let ls = [];

                for (let i in row) {
                    const inRow = row[i];
                    ls.push({
                        key: i,
                        val: inRow
                    })
                }


                return ls.map((inn) => {
                    console.log("vD 1--)=>", inn.val);
                    return (
                        <React.Fragment>
                            <span style={{color: "gray", fontWeight: "bold", fontSize: 11}}>{inn.key}</span>:
                            <span style={{color: "gray", fontSize: 11}}>{inn.val}</span>
                            <br/>
                        </React.Fragment>
                    )
                })
            })
        }

        const alertMsg = (inList) => {
            let msg = "";
            for (let h in inList) {
                const row = inList[h];
                for (let i in row) {
                    const inRow = row[i];
                    msg += "\n" + i + " : " + inRow
                }
            }
            return msg;
        }
        const taskToString = (inLs) => {
            return inLs.map((inn) => {
                console.log("vD 1--)=>", inn);
                return (
                    <React.Fragment>
                        <span style={{color: "gray", fontSize: 11}}>{inn}</span>
                        <br/>
                    </React.Fragment>
                )
            })
        }

        const styleHeader = {
            color: "white",
            background: "gray",
            fontWeight: "bold",

        }
        const innStyle = {
            color: "gray", fontSize: 11
        }

        return (
            <table className={"table"}>
                <thead>
                <tr style={{background: "gray", color: "white", maxHeight: 25, borderRadius: 1,}}>
                    <th>
                        &nbsp;
                    </th>
                    <th>Reg#</th>
                    <th>Job#</th>
                    <th>Date</th>
                    <th>Assign</th>
                    <th>Status</th>
                    <th>Created</th>
                </tr>
                </thead>
                <tbody>
                {ls.map((row) => {
                    return (
                        <tr>
                            <td width={120}>
                                <img src={row.imageLink} width={"100%"}/>
                            </td>

                            <td>
                                <span style={{...innStyle, fontWeight: "bold"}}>{row.ref}</span><br/>
                                <a
                                    onClick={() => alert(alertMsg(row.vehicleInfo))}
                                    style={{color: "#33b8ff", cursor: "pointer", fontSize: 11}}
                                >
                                    View Detail
                                </a>
                            </td>
                            <td>
                                <a
                                    onClick={() => alert(alertMsg(row.vehicleInfo))}
                                    style={{color: "red", cursor: "pointer", fontSize: 11}}
                                >
                                    {row.jobNumber}
                                </a>
                            </td>
                            <td>
                                <span style={{...innStyle, fontWeight: "bold"}}>{row.createOn}</span>
                                <br/>
                                <a
                                    onClick={() => this.openScheduleEmail(row)}
                                    style={{color: "#33b8ff", cursor: "pointer", fontSize: 11}}
                                >
                                    Send Email
                                </a>
                            </td>
                            <td>
                                <span style={{...innStyle, fontWeight: "bold"}}>{row.inChargeSource}:</span><br/>
                                <span style={{...innStyle}}>{row.inChargeName}</span>
                            </td>

                            <td style={{color: "gray", fontSize: 12}}>
                                <span style={{...innStyle}}>{row.requireStatus}</span><br/>
                                <a
                                    onClick={() => this.openChangeStatus(row)}
                                    style={{color: "#33b8ff", cursor: "pointer", fontSize: 11}}
                                >
                                    Edit Status
                                </a>
                            </td>
                            <td style={{color: "gray", fontSize: 12}}>
                                <span style={{...innStyle}}>{row.createOn}</span><br/>

                            </td>

                        </tr>
                    )

                })}
                </tbody>
            </table>
        )



    }

    renderNewSchedule = () => {


    }

    render() {

        let _this = this;
        return (
            <PageContentWallpaper {...this.props} >


                <div>

                    <div className="row">
                        <div className="col col-xs-12">
                            <h4
                                className={"alert alert-info"}
                                style={{color: "gray", fontSize: 18, textAlign: "center"}}
                            >
                                {"Pending Jobs Schedule".toLocaleUpperCase()}

                                <small>
                                    <a
                                        onClick={() => this.openNewSchedule()}
                                        className={"pull-right"}
                                        style={{color: "#33b8ff", cursor: "pointer"}}
                                    >Click here to add new Schedule
                                    </a>
                                </small>
                            </h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-xs-12">
                            {this.renderVehicleList()}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col col-xs-12">
                            <MyNewSchedule
                                _this={this}
                                popStatus={this.state.showNewSchedule}
                                popFnClose={this.closeNewSchedule}
                                vehicle={this.state.selectedVehicle}
                                vehicles={this.state.Vehicles}
                                Personnels={this.state.Personnel}
                                PersonnelAttributes={this.state.PersonnelAttributes}
                                Drivers={this.state.Drivers}
                                DriverAttributes={this.state.DriverAttributes}
                                DatabaseOptions={this.state.DatabaseOptions}
                                TableRef={"vehicle"}
                                options={this.state.DatabaseOptions}
                            />

                            <MyPopupSchStatus
                                _this={this}
                                popStatus={this.state.showScheduleStatus}
                                popFnClose={this.CloseChangeStatus}
                                options={this.state.DatabaseOptions}
                                job={this.state.selectedJob}
                            />

                            <MyPopupSchEmail
                                popStatus={this.state.showScheduleEmail}
                                popFnClose={this.CloseScheduleEmail}
                                options={this.state.DatabaseOptions}
                                job={this.state.selectedJob}
                            />
                        </div>
                    </div>


                </div>
            </PageContentWallpaper>
        )
    }

}
